import AxiosClient from '../../../services/axios.services';

class DashboardRespBossServices {
  getDashboardRespBox = params => AxiosClient.get('/api/app/On_off_bording_Dashboard_jefe_responsable/', {
    headers: {'Content-Type': 'application/json'},
    params: params
  });
}

export default new DashboardRespBossServices();